/*globals $ */

class HowtoSlider {
  constructor($el) {
    this.$el = $el;
    this.$slider = this.$el.find('.SpSliderWrap__inner');

    this.basePos = 20 - 8;
    this.touchStartPosX = 0;
    this.touchDiffPos = 0;
    this.slidePos = this.basePos;
    this.slideTargetPos = 0;
    this.currentImg = 0;
    this.visible = false;
    this.isMoveHorizontal = false;
    this.isMoveVertival = false;
    this.isMoveFinish = false;

    this.cardNum = this.$el.find('.ContentGrid__col').length;

    this.$btns = [];
    this.$el.find('.SpSliderDots__btn').each((i, e) => {
      this.$btns.push($(e));
    });


    this.$el.on('touchstart', (e) => {
      this.isMoveHorizontal = false;
      this.isMoveVertical = false;
      this.isMoveFinish = false;

      clearInterval(this.afterSwipeInterval);
      clearInterval(this.updateInterval);

      this.touchStartPosX = this.movePosX = e.originalEvent.touches[0].clientX;
      this.touchStartPosY = this.movePosY = e.originalEvent.touches[0].clientY;

      this.updateInterval = setInterval(() => {
        this.update();
      }, 1000 / 60);
    });

    this.$el.on('touchmove', (e) => {
      this.movePosX = e.originalEvent.changedTouches[0].clientX;
      this.movePosY = e.originalEvent.changedTouches[0].clientY;
    });

    this.$el.on('touchend', () => {
      clearInterval(this.updateInterval);

      this.slidePos = this.slidePos + this.lastMoveVal;

      if(!this.isMoveFinish) {
        this.isMoveFinish = true;

        if(this.lastMoveVal < 0) {
          this.currentImg += 1;
        } else {
          this.currentImg -= 1;
        }
        if(this.currentImg > this.cardNum - 1) this.currentImg = this.cardNum - 1;
        if(this.currentImg < 0) this.currentImg = 0;

        if(this.currentImg == 0) {
          this.slideTargetPos = 0;
        } else if(this.currentImg == this.cardNum - 1) {
          this.slideTargetPos = -Math.floor(this.baseWidth * this.currentImg - (window.innerWidth - 40 - this.baseWidth + 16));
        } else {
          this.slideTargetPos = -Math.floor(this.baseWidth * this.currentImg - ((window.innerWidth / 2 - this.baseWidth / 2) - 12));
        }

        this.select(this.currentImg);
      }

      clearInterval(this.afterSwipeInterval);
      this.afterSwipeInterval = setInterval(() => {
        this.updateAfterSwipe();
      }, 1000 / 60);

    });

  }

  select(target) {
    for(let i = 0; i < this.$btns.length; i++) {
      if(i == target) {
        this.$btns[i].addClass('SpSliderDots__btn--current');
      } else {
        this.$btns[i].removeClass('SpSliderDots__btn--current');
      }
    }
  }

  show(viewMode) {
    if(viewMode == 'sp') {

      this.visible = true;
      this.basePos = 20 - 8;
      setTimeout(() => {
        let _height = 0;
        this.$el.find('.ContentGrid__col').each((i, e) => {
          this.baseWidth = $(e).outerWidth();

          if(_height < $(e).height()) {
            _height = $(e).height();
          }
        });

        this.$el.css({
          'height': _height + 60
        });

        this.$el.find('.ContentGrid__col').css('height', _height);

        this.$slider.css({
          'width': (this.baseWidth + 2) * this.cardNum
        });

        this.init();
      }, 100);
    } else {
      if(this.visible == true) {
        this.$el.find('.ContentGrid__col').css('height', 'auto');
        this.$el.css({
            'height': 'auto'
          });
        this.$slider.css({
          'transform': 'translate3d(0, 0, 0)'
        });
      }
    }

  }

  hide() {
    this.visible = false;
  }

  init() {
    this.$slider.css('left', this.basePos);
    this.select(0);
  }

  update() {
    let moveValX = this.movePosX - this.touchStartPosX;
    let moveValY = this.movePosY - this.touchStartPosY;

    if(Math.abs(moveValY) > Math.abs(moveValX)) {
      // this.isMoveVertical = true;
      this.isMoveFinish = true;
    }

    this.lastMoveVal = moveValX;
    this.$slider.css({
      'transform': 'translate3d(' + String(this.slidePos + moveValX) + 'px, 0, 0)'
    });

  }

  updateAfterSwipe() {
    this.slidePos += (this.slideTargetPos - this.slidePos) / 3;
    if(Math.abs(this.slideTargetPos - this.slidePos) < 1) {
      clearInterval(this.afterSwipeInterval);
      this.slidePos = this.slideTargetPos;
    }

    this.$slider.css({
      'transform': 'translate3d(' + this.slidePos + 'px, 0, 0)'
    });
  }
}

export default HowtoSlider;
